module.exports = __webpack_public_path__ + "img/ico4.55469cef.png";